import React from "react";

export default function formatRawHtml(rawHTML: string) {
  return React.createElement("span", {
    dangerouslySetInnerHTML: { __html: rawHTML },
  });
}
